module.exports = {
      id: "icons:paper-plane-usage",
      viewBox: "0 0 17 16",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#icons:paper-plane-usage",
      toString: function () {
        return this.url;
      }
    }